import nanoajax from "nanoajax";
import slugify from "slugify";
import Swiper from "swiper";
import { feriadosData } from "../../shared/feriadosData";
import { getItemsOnBlog } from "../../shared/utils";
import { BFF_API } from "../../shared/constants";
import { formatCurrency } from "../../shared/utils";

export const createComponentsPassagensPromocionais = () => {
	if (document.body.className.match(".passagens-promocionais")) {
		const urlBuscaPassagens = BFF_API;

		const limitPostsBlog = 8;

		const blogDestinosContent = document.querySelector(".list-passagens .blog-destinos ul");
		const blogViagensContent = document.querySelector(".list-passagens .blog-viagem ul");

		nanoajax.ajax(
			{
				url: `https://www.maxmilhas.com.br/blog/?feed=rss2&s=Destinos`,
				method: "GET"
			},
			function(code, responseText, request) {
				let data;

				document.querySelector(".list-passagens .blog-destinos .loading").remove();

				if (code === 200) {
					if (window.DOMParser) {
						const parser = new DOMParser();
						data = parser.parseFromString(responseText, "text/xml");
					} else {
						// Internet Explorer
						data = new ActiveXObject("Microsoft.XMLDOM");
						data.async = false;
						data.loadXML(responseText);
					}

					const channelXML = data.getElementsByTagName("channel")[0];

					const { length } = getItemsOnBlog(channelXML.getElementsByTagName("item"));

					for (var i = 0; i < limitPostsBlog; i++) {
						const item = channelXML.getElementsByTagName("item")[i];
						const title =
							typeof item.getElementsByTagName("title")[0] !== "undefined"
								? item.getElementsByTagName("title")[0].textContent
								: "";
						const link =
							typeof item.getElementsByTagName("link")[0] !== "undefined"
								? item.getElementsByTagName("link")[0].textContent
								: "";

						blogDestinosContent.innerHTML += `<li><a href="${link.replace(/https:\/\/maxmilhas\.wpengine\.com/, 'https://www.maxmilhas.com.br/blog')}">${title}</a></li>`;
					}
				} else {
					blogDestinosContent.innerHTML += `<li>Ocorreu um erro ao buscar posts no blog, tente novamente.</li>`;
				}
			}
		);

		nanoajax.ajax(
			{
				url: `https://www.maxmilhas.com.br/blog/?feed=rss2&s=Dicas de viagem`,
				method: "GET"
			},
			function(code, responseText, request) {
				let data;

				document.querySelector(".list-passagens .blog-viagem .loading").remove();

				if (code === 200) {
					if (window.DOMParser) {
						const parser = new DOMParser();
						data = parser.parseFromString(responseText, "text/xml");
					} else {
						// Internet Explorer
						data = new ActiveXObject("Microsoft.XMLDOM");
						data.async = false;
						data.loadXML(responseText);
					}

					const channelXML = data.getElementsByTagName("channel")[0];

					const { length } = getItemsOnBlog(channelXML.getElementsByTagName("item"));

					for (var i = 0; i < limitPostsBlog; i++) {
						const item = channelXML.getElementsByTagName("item")[i];
						const title = item.getElementsByTagName("title")[0].textContent;
						const link = item.getElementsByTagName("link")[0].textContent;

						blogViagensContent.innerHTML += `<li><a href="${link.replace(/https:\/\/maxmilhas\.wpengine\.com/, 'https://www.maxmilhas.com.br/blog')}">${title}</a></li>`;
					}
				} else {
					blogViagensContent.innerHTML += `<li>Ocorreu um erro ao buscar posts no blog, tente novamente.</li>`;
				}
			}
		);

		const buscaPrecosFeriados = () => {
			let requestsBuscaPrecosFeriados = [];
			let precosFeriados = [];

			feriadosData.map((feriado, i) => {
				requestsBuscaPrecosFeriados.push(
					new Promise((resolve, reject) => {
						if (
							feriado["feriado"] == "black-friday" ||
							feriado["feriado"] == "dia-mundial-das-milhas"
						) {
							resolve();

							return false;
						}

						return nanoajax.ajax(
							{
								url: `${urlBuscaPassagens}/best-prices/flights?min_outbound_date=${
									feriado["min"]
								}&max_outbound_date=${feriado["max"]}&size=1&exclusivo_maxmilhas=false`,
								method: "GET"
							},
							function(code, responseText, request) {
								if (code !== 200 || !responseText || !JSON.parse(responseText).length) {
									resolve();

									return false;
								}

								const data = JSON.parse(responseText);
								const item = data[0];

								const price = formatCurrency(item.best_price_mm_w_taxes);

								precosFeriados.push({
									name: feriado["feriado"],
									value: price
								});

								resolve();
							}
						);
					})
				);
			});

			Promise.all(requestsBuscaPrecosFeriados)
				.then(error => {
					precosFeriados.map(item => {
						document.querySelector(
							`.${item["name"]}-card .card-largetitle-item--title h3`
						).innerHTML = `A partir de <span>${item["value"]}</span>`;
					});
				})
				.catch(() => {
					console.error("Tivemos um erro ao capturar preços dos feriados.");
				});
		};

		buscaPrecosFeriados();
	}
};

// Check if date has passed before mounting slider
// If passed send card to end
const checkDate = function() {
	const dateToday = document.querySelector(".date-today")
		? document.querySelector(".date-today").innerHTML
		: "";
	const dateIsPast = d => Date.parse(d) - Date.parse(new Date()) < 0;
	const parent = document.querySelector("#swiper-cards .swiper-wrapper");
	const slides = parent && Array.from(parent.querySelectorAll("#swiper-cards .swiper-slide"));

	slides &&
		slides.forEach(node => {
			try {
				let date = node.attributes["data-date"].value;
				date = date.split("-");
				date = `${date[2]}/${date[0]}/${date[1]} 00:00:00 AM GMT-0300`;

				const currentYear = new Date().getFullYear();
				const newYear = currentYear + 1;

				const isPast = dateIsPast(date);
				if (isPast) {
					parent.appendChild(node);

					const html = node.innerHTML;
					node.innerHTML = html.replace(new RegExp(currentYear, "g"), newYear);
				}
			} catch (err) {
				return;
			}
		});
};

checkDate();

// encapsula slides de 4 em 4 para exibição da ordem correta em linhas
function wrapSlides() {
	const wrapper = document.createElement("div");
	wrapper.classList.add("swiper-slide-parent");
	wrapper.classList.add("swiper-slide");
	const els = Array.from(arguments);
	const first = arguments[0];
	first.parentNode.insertBefore(wrapper, first);

	els.filter(el => el).forEach(el => wrapper.appendChild(el));
}

if (window.outerWidth > 768) {
	const destinationSlides = document.querySelectorAll("#swiper-cards .swiper-slide");
	for (let i = 0; i < destinationSlides.length; i += 4) {
		wrapSlides(
			destinationSlides[i],
			destinationSlides[i + 1],
			destinationSlides[i + 2],
			destinationSlides[i + 3]
		);
	}
}

var swiperDestination = new Swiper("#swiper-cards .swiper-container", {
	pagination: {
		el: "#swiper-cards .swiper-pagination",
		clickable: true
	},
	simulateTouch: false,
	loop: false,
	slidesPerColumnFill: 'row',
	navigation: {
		nextEl: "#swiper-cards .swiper-button-next",
		prevEl: "#swiper-cards .swiper-button-prev",
	},
	breakpoints: {
		768: {
			simulateTouch: true,
			slidesPerView: 1,
			slidesPerGroup: 1,
			slidesPerColumn: 1,
			spaceBetween: 30,
			loop: true
		}
	}
});
